module.exports = __webpack_public_path__ + "img/C05TechBalearicSlingerChampion_ua.d432d86f.webp";